import { getBuildInfo } from '@confluence/build-info';
import { Cookies } from '@confluence/cookies';

const BRANCH_COOKIE = 'useFrontendBranch';
const BIFROST_OVERRIDE_COOKIE = 'bifrost-override';

const isActiveBranchCookie = (value: string | undefined): boolean | undefined => {
	if (!value || value === 'off') {
		return false;
	}

	const override = JSON.parse(value);
	if (!override || typeof override !== 'object' || Array.isArray(override)) {
		return undefined;
	}
	const version = override?.['cc-fe-bifrost']?.version ?? override?.version;
	if (version === undefined) {
		return false;
	}
	return typeof version === 'string'
		? Boolean(version && version !== 'off' && version !== 'CLASSIC-off-off')
		: undefined;
};

export const getConfluenceNonProductionBuild = (): boolean | undefined => {
	if (process.env.CLOUD_ENV === 'branch-fedm') {
		return true;
	}

	try {
		const { RELEASE_TRACK } = getBuildInfo();

		if (RELEASE_TRACK === 'dev' || RELEASE_TRACK === 'staging') {
			return true;
		}

		if (!['prod', 'hello', 'canary'].includes(RELEASE_TRACK)) {
			return undefined;
		}

		if (window.__SSR_RENDERED__) {
			let bifrostOverride;
			try {
				bifrostOverride = Cookies.get(BIFROST_OVERRIDE_COOKIE);
			} catch {
				// Fall back to the frontend branch cookie if the Bifrost cookie cannot be read.
			}

			if (bifrostOverride) {
				return isActiveBranchCookie(bifrostOverride);
			}
		}

		const branchVersion = Cookies.get(BRANCH_COOKIE);
		return Boolean(branchVersion && branchVersion !== 'off');
	} catch {
		return undefined;
	}
};
